// the admin pages: People, Teams, Settings, Memory, Feedback, Audit (R10-Q16).
export const admin = {
  // Shared by the admin pages.
  saveChanges: "Save changes",
  name: "Name",
  email: "Email",
  title: "Title",
  archived: "Archived",
  newTag: "New",
  peopleCount_one: "{n} person",
  peopleCount_other: "{n} people",
  aboutTeam: "About this team",
  newTeamsHint: "New teams start with company memory only, until you grant sources.",
  reachBy: "Reach by",
  reachWeb: "Web",
  reachEmail: "Email",
  reachBoth: "Both",
  toolAccounts: "Tool accounts",
  deactivated: "Deactivated",
  invitedNotSignedIn: "Invited, not signed in",
  notNeeded: "not needed",

  // People.
  whatPeople: "people",
  peopleSubtitle: "{people} and Vantage · Vantage reads every profile on every turn",
  setUpWithVantage: "Set up with Vantage",
  setupAsk: "Set up a new teammate: ",
  invite: "Invite",
  searchPeopleDots: "Search people…",
  searchPeople: "Search people",
  filterAll: "All",
  filterAdmins: "Admins",
  needsAttention: "Needs attention",
  colPersonAbout: "Person · About",
  colStatus: "Status",
  vantageAbout: "Works through its own Redmine, GitHub and Outline accounts.",
  vantageTitle: "AI teammate · admin accounts",
  openDetails: "{name}, open details",
  acctLinked: "linked",
  acctMissing: "missing",
  acctHeld: "held for an admin",
  acctNotCheckedYet: "not checked yet",

  // A person's panel.
  personDetails: "Person details",
  newPerson: "New person",
  person: "Person",
  profile: "Profile",
  called: "Called",
  fullName: "Full name",
  about: "About",
  aboutHelp:
    "Visible company-wide. Vantage reads this on every turn to route questions and tasks to the right person.",
  language: "Language",
  matchTheirMessage: "Match their message",
  teamsAndRole: "Teams and role",
  removeFrom: "Remove from {team}",
  addToTeam: "Add to a team",
  inEveryTeam: "In every team already",
  role: "Role",
  matchedBy: "matched by {by}",
  matchedEmail: "email",
  matchedName: "name",
  matchedManual: "manual",
  noAccountFound: "no account found",
  checkedWhenConnect: "checked when the tools connect (round 1)",
  linked: "Linked",
  missing: "Missing",
  notNeededLabel: "Not needed",
  notChecked: "Not checked",
  held: "Held",
  linkTo: "Link {login}",
  addPerson: "Add person",
  addedName: "Added {name}.",
  saved: "Saved.",
  couldntSave: "Couldn't save.",
  activeAgain: "{name} is active again.",
  deactivate: "Deactivate",
  deactivateTitle: "Deactivate {name}?",
  deactivateBody:
    "They're signed out everywhere at once and can't sign in until an admin reactivates them. Their history stays.",
  deactivatedName: "{name} deactivated",
  emailChangeTitle: "Change {name}'s email?",
  emailChangeBody:
    "They're signed out everywhere, and their passkeys and device notifications are removed. They sign in again with {email}.",
  changeEmail: "Change email",
  reactivate: "Reactivate",

  // Teams.
  teamsSubtitle: "Each team gets a channel, its own memory, and only the sources you grant",
  hideArchived: "Hide archived",
  showArchived: "Show archived",
  whatTeams: "teams",
  whatTheTeams: "the teams",
  wholeCompany: "Whole company · {n} people",
  newTeam: "New team",
  createTeam: "Create team",
  createdTeam: "Created {team}. Grant it sources next.",
  couldntCreateTeam: "Couldn't create the team.",
  syncToolFailed: "{tool} failed",
  withoutAccess: "{n} without access",
  synced: "Synced: {list}",
  syncFailed: "Sync failed. Try again in a minute.",
  syncing: "Syncing…",
  syncNow: "Sync now",
  noAccessYet_one: "{n} item has no access yet:",
  noAccessYet_other: "{n} items have no access yet:",
  andMore: "and {n} more",
  grantBelow: "Grant them to a team below; they're marked New.",

  // A team's editor.
  savedName: "Saved {name}.",
  channelEveryone: "Channel #everyone · the whole company",
  channelSlug: "Channel #{slug}",
  everyoneKeepsName: "Everyone is the whole company: it keeps its name.",
  channelTakesName: "The team's channel takes the new name too.",
  aboutTeamHelp: "Vantage uses this to decide which team a new fact belongs to.",
  listenIn: "Listen in #{slug} for team memory",
  listenHelp:
    'Shown to members in the channel header. Messages that start with "off the record" are skipped.',
  listenToggle: "Listen for team memory",
  channelIcon: "Channel icon",
  channelIconSub:
    "Shown wherever the team appears: next to #{slug} in the Team list and its header, and on the team's automations and people",
  // The channel icons' names (said lowercase; the tooltip capitalises them).
  iconCode: "code",
  iconTerminal: "terminal",
  iconRocket: "rocket",
  iconFlask: "flask",
  iconWrench: "wrench",
  iconShield: "shield",
  iconChart: "chart",
  iconPalette: "palette",
  iconCamera: "camera",
  iconHeart: "heart",
  iconBriefcase: "briefcase",
  iconUsers: "users",
  iconMegaphone: "megaphone",
  iconCart: "cart",
  iconGlobe: "globe",
  iconBook: "book",
  iconStar: "star",
  iconCoffee: "coffee",
  colour: "Colour",
  preview: "Preview",
  members: "Members",
  everyActivePerson: "every active person",
  addPeople: "Add people",
  everyoneInTeam: "Everyone is in this team",
  removeName: "Remove {name}",
  noMembersYet: "No members yet.",
  toolRedmine: "Redmine projects",
  toolGithub: "GitHub repositories",
  toolGithubSub: "in bcsw",
  toolOutline: "Outline collections",
  reachThroughVantage: "what {team} can reach through Vantage",
  setAll: "Set all",
  setAllOf: "Set all {what}",
  everyCurrentItem: "Every current item",
  nothingUntilSync: "Nothing here yet: items appear after the first sync.",
  fenceMeta: "{id} · used by automated tests, cleaned after every run",
  adminPowers: "Admin powers",
  adminPowersSub: "what {team} may ask Vantage to do as an admin",
  powerGithub: "Create repos and manage GitHub teams",
  powerGithubHint: '"Make a repo for the new client project"',
  powerRedmine: "Manage Redmine projects and members",
  powerRedmineHint: '"Add Linh to the Family Tree project"',
  powerOutline: "Manage Outline collections",
  powerOutlineHint: '"Make an Outline collection for the Q4 planning docs"',
  powerPeople: "Set up people's accounts",
  powerPeopleHint: "Onboarding across Redmine, GitHub and Outline",
  powerAutomations: "Create automations for this team",
  powerAutomationsHint: "Scheduled posts and alerts in the team channel",
  // {a} is "a" or "an" (English only: other languages leave it out).
  memberExperiences: "What {a} {team} member experiences",
  everyoneExperiences: "What everyone experiences",
  saveToUpdatePreview: "Save to update this preview.",
  accessLevels: "Access levels",
  levelNoneHint: "invisible to this team",
  levelReadHint: "see and search",
  levelWriteHint: "create and update",
  levelManageHint: "also delete and admin changes; Vantage always asks first",
  backFromArchive:
    "{team} is back. Its automations stay paused: resume them on the Automations page.",
  archivedBody: "Its channel is empty and read-only, its automations paused.",
  openChannelReadOnly: "Open channel (read-only)",
  unarchiveTeam: "Unarchive team",
  deleteTeam: "Delete team",
  deleteTitle: "Delete #{slug} for good?",
  counting: "Counting what goes with it…",
  couldntCount: "Couldn't count what goes with it.",
  erasedWithIt: "Erased with it: {list}. This can't be undone.",
  nothingElse: "Nothing else goes with it. This can't be undone.",
  typeNameToConfirm: "Type the team's name to confirm",
  deletedSlug: "Deleted #{slug}.",
  messagesCount_one: "{n} message",
  messagesCount_other: "{n} messages",
  filesCount_one: "{n} file",
  filesCount_other: "{n} files",
  factsCount_one: "{n} fact",
  factsCount_other: "{n} facts",
  lessonsCount_one: "{n} lesson",
  lessonsCount_other: "{n} lessons",
  teamNotesCount_one: "{n} team note",
  teamNotesCount_other: "{n} team notes",
  automationsCount_one: "{n} automation",
  automationsCount_other: "{n} automations",
  archiveTeam: "Archive team",
  archiveTitle: "Archive {team}?",
  archiveBody:
    "#{slug} empties: its members lose it from their list and Vantage stops listening there. Its history stays (admins can still read it), and its automations pause. Unarchive brings the members back.",
  archivedName: "Archived {team}.",

  // Settings.
  whatSettings: "the settings",
  settingsSaved: "Settings saved.",
  settingsSubtitle: "Spend, models and switches · every change is in the audit log",
  capMonthly: "Per month",
  capDaily: "Per day",
  capPersonDaily: "Per person per day",
  capFastTurn: "Per fast answer",
  capDeepTask: "Per deep report",
  fastAnswers: "Fast answers",
  fastAnswersHint: "most questions · thinking bounded",
  deepReports: "Deep reports",
  deepReportsHint: "plans, checks and writes the report",
  sideTasks: "Side tasks",
  sideTasksHint: "titles, summaries, the memory curator",
  vision: "Images and scanned PDFs",
  visionHint: "vision",
  searchIndex: "Search index",
  searchIndexHint: "embeddings (local model)",
  memory: "Memory",
  memoryHint: 'Vantage saves what it learns and shows "Remembered … · Undo"',
  listening: "Listening in team channels",
  listeningHint: "Each team can also turn it off on the Teams page",
  automations: "Automations",
  automationsHint: "Scheduled posts and alerts",
  memoryAndEmbeddings: "Memory and embeddings",
  titlesSummariesRouting: "Titles, summaries and routing",
  evals: "Evals",
  senderDmarc: "DMARC only (strict)",
  senderDmarcHelp:
    "Only mail our server checked and found to pass DMARC is trusted; the rest waits in quarantine.",
  senderSubmission: "Also trust colleagues' mail sent through our mail server",
  senderSubmissionHelp:
    "Also mail a colleague sent while signed in to our own mail server, from their own address.",
  ownMailbox: "Vantage's own mailbox",
  emailHelp:
    'Vantage answers mail from people in Vantage EX, sends "Email me", relays, reminders and digests. Off: only sign-in mail goes out.',
  senderCheck: "Sender check",
  senderCheckHelp: "Who counts as a colleague when a mail comes in.",
  uploadLimit: "Upload limit (MB)",
  previewPages: "Preview pages",
  previewRows: "Preview rows per sheet",
  files: "Files",
  filesSub: "uploads and the previewer",
  filesHelp:
    "A preview draws a file's first pages and shows each sheet's first rows. A change applies to new previews only.",
  spend: "Spend",
  spendSub: "model and embedding costs · the month resets on {date}",
  todayOf: "today of {cap}",
  monthOf: "this month of {cap}",
  topPersonToday: "top person today · {name}",
  noSpendToday: "no one has spent today",
  avgFastAnswer: "average fast answer",
  thisMonth: "This month",
  capUsedAria: "{pct}% of the monthly cap used",
  pctOfCap: "{pct}% of the cap",
  noSpendYet: "No spend yet this month.",
  calls_one: "{n} call",
  calls_other: "{n} calls",
  backgroundWorker: "Background worker",
  mail: "Mail",
  toolSync: "{tool} sync",
  toolNamed: "Tool: {name}",
  models: "Models",
  healthOk: "OK",
  healthDegraded: "Degraded",
  healthDown: "Down",
  on: "On",
  off: "Off",
  systemHealth: "System health",
  checkedAt: "checked {time}",
  version: "Version",
  commit: "commit {commit}",
  appAndDatabase: "App and database",
  checking: "Checking",
  lastChecked: "last checked {time}",
  spendCaps: "Spend caps",
  inUsd: "in US dollars",
  capsHelp:
    "When a cap is reached, automations pause first, new questions get \"I've reached today's spend limit. An admin can raise it in Settings.\", and admins get a notification.",
  pricedModels: "{n} priced models",
  noPrices: "no prices recorded yet",
  notChosen: "Not chosen yet",
  pricesHelp: "Prices per million tokens drive every cost shown in Vantage.",
  switches: "Switches",
  switchesSub: "turn a whole feature off, for everyone",
  company: "Company",
  timeZone: "Time zone",
  emailDomains: "Company email domains",
  domainsHelp: "Vantage only invites people with an address on these domains.",
  testMode: "Test mode",
  testModeOn:
    "Vantage can only write to the Test project, the Vantage Test collection and agent-sandbox.",
  testModeOff: "Vantage acts on the real Redmine, GitHub and Outline, the way people ask.",
  testModeFenced:
    "Set by the server, not here. Automated tests always run fenced: they can only write to the Test project, the Vantage Test collection and agent-sandbox.",
};
